import CourseController from "../diagrams/course.controller";

class FullWordingIntroductionPaperController extends CourseController {

  showMintoIntroduction = false;
  fullWordingOfIntroduction = true
  studentAnswerRows = 12;
  expandedBgHeight = '0px'
  userAnswerInput = ''
  userAnswer = 'VIEW YOUR TEXT'
  schoolAnswer = 'VIEW SCHOOL SOLUTION'
  buttonText = this.schoolAnswer

  constructor(courseService, helperService, $translate, $scope) {
    'ngInject';
    super(courseService, helperService, $translate, $scope);
    const date = new Date()
    const dateOptions = { month: 'long', day: 'numeric', year: 'numeric' }
    this.currentDate = date.toLocaleDateString('en-EN', dateOptions)
  }

  toogleMintoIntroduction () {
    this.showMintoIntroduction = !this.showMintoIntroduction
    this.buttonText = this.showMintoIntroduction ? this.userAnswer : this.schoolAnswer
    // this.studentAnswerRows = 4
    //
    // const textField = $(document.querySelector(`#${this.diagramId} .student-paper-answer__field`))
    // const inputText = textField.val()
    // const inputWidth = textField.css('width')
    // this.inputLineHeight = parseInt(textField.css('line-height').slice(0, -2))
    //
    // const div = document.querySelector(`#${this.diagramId} #check-lines`)
    // const textarea = document.createElement('textarea')
    // textarea.classList.add('student-paper-answer__field')
    // textarea.value = inputText
    // textarea.style.width = inputWidth
    //
    // div.appendChild(textarea)
    // const scrollHeight = textarea.scrollHeight
    //
    // div.parentNode.removeChild(div);
    //
    // this.userAnswerRowsCount = Math.floor(scrollHeight / this.inputLineHeight)
    //
    // this.isUserAnswerBigger = this.userAnswerRowsCount > 4
  }

  expandUserAnswer() {
    this.studentAnswerRows = this.userAnswerRowsCount

    const fullWording = $(`#${this.diagramId}`)
    const diagramHeight = fullWording.height()

    const growHeight = this.userAnswerRowsCount * this.inputLineHeight + 16
    fullWording.height(diagramHeight + growHeight)
    this.isUserAnswerExpanded = true
    this.expandedBgHeight = growHeight + 'px'
    //  move buttons
    const nextButton = $(document.querySelector(`#${this.diagramId} #next`))
    nextButton.css({top: diagramHeight + growHeight - 660 + 'px', position: 'relative'})
  }
}

export default FullWordingIntroductionPaperController;



// WEBPACK FOOTER //
// ./client/app/components/fullWordingIntroductionPaper/fullWordingIntroductionPaper.controller.js